import { render, staticRenderFns } from "./ApplicantRegister.vue?vue&type=template&id=3b5cc36c&"
import script from "./ApplicantRegister.vue?vue&type=script&lang=js&"
export * from "./ApplicantRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../var/www/laravel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports